import { devDomain } from './dev.domain';

export const ignoreHosts: string[] = [
  'https://spinpanda.com',
  'localhost',
  'dev.',
  ...devDomain,
];
